import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { emptyStringValues } from '@/utils/objects';

import { ProductionCenterParametersType, ProductionCenterTypeEnum } from '../types';

import { productionCenterQueryKeys } from './query-keys';

export type TPostProductionCenterParams = {
  name: string;
  description?: string | null;
  production_center_type: ProductionCenterTypeEnum;
  parameters?: ProductionCenterParametersType | null;
};

export async function postProductionCenter(body: TPostProductionCenterParams): Promise<unknown[]> {
  return mediaManagerClient
    .post('/api/v1/production_centers', emptyStringValues(body))
    .then(({ data }) => data);
}

type MutationFn = typeof postProductionCenter;

type TUsePostProductionCenterParams = {
  config?: MutationConfig<MutationFn>;
};

export function usePostProductionCenter({ config = {} }: TUsePostProductionCenterParams = {}) {
  const { t } = useTranslation();
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    ...config,
    mutationFn: postProductionCenter,
    onError(error) {
      addErrorNotification(t('No se ha podido crear el centro de producción'));
      console.error(error);
    },
    onSuccess() {
      addSuccessNotification(t('El centro de producción se ha creado'));
      queryClient.invalidateQueries({ queryKey: productionCenterQueryKeys.all });
    },
  });
}
